











import ClickOutside from 'v-click-outside'
import { Component, Vue, Prop } from 'vue-property-decorator'

export enum Positions {
  left = 'left',
  right = 'right'
}

@Component({
  directives: {
    clickOutside: ClickOutside.directive
  }
})
export default class DropdownButton extends Vue {
  @Prop({ default: 'div' }) readonly element!: string
  @Prop({ default: '' }) readonly position!: Positions
  @Prop({ default: false }) readonly keepOpen!: boolean

  open: boolean = false

  close () {
    this.open = false
  }

  get dynamicComponent () {
    return {
      template: `<${this.element}><slot/></${this.element}>`
    }
  }
}

